export const getUserIdWithFallback = (updUserId, insUserId) => {
  // Return updUserId if it has a value, otherwise fallback to insUserId
  return updUserId != null ? String(updUserId) : String(insUserId || '');
};

export default getUserIdWithFallback;
